import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

/**
 * AutoSaveIndicator - Visual feedback for save state
 *
 * Shows one of two states:
 * - Saving: Spinner animation
 * - Error: Red error icon (if save failed)
 * - Saved: Nothing (silent success)
 *
 * @param {boolean} saving - True if currently saving
 * @param {boolean} error - True if last save failed
 */
function AutoSaveIndicator({ saving = false, error = false }) {
  if (saving) {
    return (
      <div className="flex items-center text-gray-400" title="Saving...">
        <Loader2 className="w-5 h-5 animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center text-red-400" title="Save failed">
        <AlertCircle className="w-5 h-5" />
      </div>
    );
  }

  // Default: Saved state - show nothing
  return null;
}

export default AutoSaveIndicator;
